<template>
  <div class="comment-reply">
    <button
      class="btn btn-reply"
      @click="showHide"
      v-bind:class="[isReplyBtnPressed ? 'btn--selected' : '']"
      v-if="$pageType === 'comment'"
    >
      <span class="btn-text">返信 {{replyCount}}件</span>
      <svg
        class="icon icon-r icon-arrow"
        width="12"
        height="7.4"
        viewBox="0 0 12 7.4"
        fill-rule="evenodd"
      >
        <title>下矢印</title>
        <path
          d="M12,8,6,14l1.41,1.41L12,10.83l4.59,4.58L18,14Z"
          transform="translate(18 16) rotate(-180)"
        ></path>
      </svg>
    </button>
    <div class="comment-reply-text" v-else>返信 {{replyCount}}件</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'commentReply',
  data: function () {
    const flag = localStorage.getItem(`before_reply_${this.comment.uuid}`)
    if (flag) {
      const flagData = JSON.parse(flag)
      if (flagData && flagData.expired_at > new Date().getTime()) {
        this.replyShowHide(this.i)
        return {
          isReplyBtnPressed: true
        }
      }
    }
    return {
      isReplyBtnPressed: false
    }
  },
  props: {
    i: Number,
    comment: Object,
    replyCount: Number
  },
  computed: {},
  methods: {
    ...mapActions('commentsData', ['replyShowHide','replyFlagSet']),
    showHide () {
      const flag = localStorage.getItem(`before_reply_${this.comment.uuid}`)
      if (flag) {
        const flagData = JSON.parse(flag)
        if (flagData && flagData.expired_at > new Date().getTime()) {
          this.isReplyBtnPressed = true
          //this.replyShowHide(this.i)
          this.replyFlagSet({
            index: this.i,
            show: true
          })
          return
        }
      }
      this.isReplyBtnPressed = !this.isReplyBtnPressed
      this.replyShowHide(this.i)
    }
  }
}
</script>

<style lang="scss" src="./commentReply.scss"></style>



// WEBPACK FOOTER //
// src/components/molecules/commentReply/commentReply.vue